<template>
 <PageHeading
  :button-title="$t('new rule')"
  :has-meta-data="false"
  :has-search="true"
  :has-action-button="true"
  :first-button-title="
   userPermissions.permissions.includes('smart-routings.*') ||
   userPermissions.permissions.includes('smart-routings.edit')
    ? $t('importFile')
    : undefined
  "
  :last-button-title="
   userPermissions.permissions.includes('smart-routings.*') ||
   userPermissions.permissions.includes('smart-routings.delete')
    ? $t('deleteAll')
    : undefined
  "
  :has-permission="
   userPermissions.permissions.includes('smart-routings.*') ||
   userPermissions.permissions.includes('smart-routings.create')
  "
  @import="isPopoverOpen = !isPopoverOpen"
  :title="$t('inbound rules')"
  @open="(this.openForm = !this.openForm), (this.openUpdateForm = false)"
  @update:search="$emit('update:search', $event)" />
 <div class="flex flex-col" v-if="this.openForm">
  <div class="-my-0 overflow-x-auto sm:-mx-6 lg:-mx-0">
   <div class="pt-5 align-middle inline-block min-w-full sm:px-6 lg:px-10">
    <div class="rounded overflow-hidden border border-gray-200">
     <CreateNewCallQueue
      :hostName="hostName"
      :hostsNameOptions="hostsNameOptions"
      :hostsOptions="hostsOptions"
      :callQueuesOptions="callQueuesOptions"
      :title="$t('callqueue.newFormTitle')"
      :subTitle="$t('callqueue.formSubTitle')"
      :callQueuesGroups="this.callQueuesGroups"
      :editData="editData"
      :openUpdateForm="openUpdateForm"
      @activeBanner="$emit('activeBanner'), getCallQueuesLists()"
      @successMsg="$emit('successMsg', $event)"
      @success="$emit('success', $event)"
      @closeForm="this.openForm = false" />
    </div>
   </div>
  </div>
 </div>
 <div class="flex flex-col mb-4" v-if="this.openUpdateForm && this.openBulkEditForm === false && this.itemsSelected === false">
  <div class="-my-0 overflow-x-auto sm:-mx-6 lg:-mx-0">
   <div class="pt-5 align-middle inline-block min-w-full sm:px-6 lg:px-10">
    <div class="rounded overflow-hidden shadow">
     <CreateNewCallQueue
      :hostName="hostName"
      :hostsNameOptions="hostsNameOptions"
      :hostsOptions="hostsOptions"
      :callQueuesOptions="callQueuesOptions"
      :title="$t('callqueue.updateFormTitle')"
      :subTitle="$t('callqueue.formSubTitle')"
      :callQueuesGroups="this.callQueuesGroups"
      :editData="editData"
      :openUpdateForm="openUpdateForm"
      @activeBanner="$emit('activeBanner'), getCallQueuesLists()"
      @successMsg="$emit('successMsg', $event)"
      @success="$emit('success', $event)"
      @closeForm="this.openUpdateForm = false" />
     <!--   <UpdateCallQueueForm
      v-on:closeForm="this.openUpdateForm = false"
      :title="$t('callqueue.updateFormTitle')"
      :id="this.callQueueId"
      :name="this.callQueueName"
      :callQueuesGroups="this.callQueuesGroups"
      @activeBanner="
       (activeBanner = true), getCallQueuesLists(), (key = !key), (this.openUpdateForm = false)
      "
      @successMsg="successMsg = $event"
      @success="isSuccess = $event"
     /> -->
    </div>
   </div>
  </div>
 </div>
 <div
  v-show="isPopoverOpen"
  class="max-w-7xl mx-auto bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
  <div class="p-4 w-full">
   <div
    class="flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md hover:border-gray-500"
    @drop="dropHandler($event)"
    @dragover="dragOverHandler($event)">
    <div class="space-y-1 text-center">
     <svg
      xmlns="http://www.w3.org/2000/svg"
      class="mx-auto h-12 w-12 text-gray-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1">
      <path
       stroke-linecap="round"
       stroke-linejoin="round"
       d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
     </svg>
     <div class="flex justify-center text-sm text-gray-600">
      <label
       for="file-upload"
       class="relative cursor-pointer rounded-md font-medium text-main-color">
       <span> {{ $t("uploadAFile") }}</span>
       <input
        id="file-upload"
        name="file-upload"
        type="file"
        ref="file"
        class="sr-only"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
        @change="handleFileUpload($event)" />
      </label>
      <p class="pl-1">{{ $t("or") }} {{ $t("dragAndDrop") }}</p>
     </div>

     <div class="flex justify-center">
      <ExclamationCircleIcon
       v-show="errorFormMandateUpload"
       class="h-4 w-4 text-red-500 mr-1"
       aria-hidden="true" />
      <p
       :class="
        errorFormMandateUpload
         ? 'text-xs text-red-600'
         : 'text-xs text-gray-500'
       ">
       {{ $t("onlyFileAccepterd", { file: "excel" }) }}
      </p>
     </div>
     <p v-show="this.file.name" class="text-sm text-gray-700">
      <font-awesome-icon
       icon="file-import"
       class="h-4 w-4 text-gray-500"
       aria-hidden="true" />
      {{ this.file.name }}
     </p>
     <div class="flex gap-2 items-center justify-center">
      <button
       @click="downloadExcelFile"
       class="text-sm text-blue-600 underline">
       {{ $t("Donwload excel example file") }}
      </button>
     </div>
     <div class="flex gap-2 items-center px-4 py-3 sm:px-6 justify-center">
      <input
       type="checkbox"
       name="replace_all"
       id="replace_all"
       v-model="replaceAll"
       class="w-4 h-4 border-gray-300 rounded focus:encom_border_input" />
      <p class="text-sm font-bold text-gray-500">{{ $t("Replace all") }}</p>
     </div>
    </div>
   </div>
  </div>

  <button
   v-show="this.file"
   @click="submitFile('Please insert file')"
   type="button"
   class="max-w-7xl mx-auto uppercase rounded group body__header--button sm:text-sm lg:text-sm xl:text-sm md:text-sm text-white flex justify-end items-center text-sm font-medium shadow p-2">
   {{ $t("upload") }}
  </button>
  <div class="rounded-md bg-blue-50 p-4 m-4">
   <div class="flex">
    <div class="flex-shrink-0">
     <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      class="h-5 w-5 text-blue-400">
      <path
       fill-rule="evenodd"
       d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
       clip-rule="evenodd" />
     </svg>
    </div>
    <div class="ml-3 flex-1 md:flex md:justify-between">
     <p class="text-sm text-blue-700">
      {{ $t("uploadAFileInboundRules") }}
     </p>
    </div>
   </div>
  </div>
 </div>
 <div class="flex flex-col">
  <div class="-my-0 sm:-mx-6 lg:-mx-0">
   <div
    v-if="callQueuesLists?.length > 0"
    class="align-middle inline-block min-w-full sm:px-6 lg:px-10">
    <CallQueuesTable
     :account="this.account"
     :thead="thead"
     :tbody="filterCallQueuesLists()"
     :openForm="openForm"
     :openUpdateForm="openUpdateForm"
     @openEditForm="openEditForm($event)"
     @openBulkEditForm="openBulkEditForm = true"
     @closeBulkForm="openBulkEditForm = false"
     @closeForm="openUpdateForm = false"
     @itemsSelected="itemsSelected = $event"
     @bulkDelete="bulkDelete($event)"
     @refreshQueueList="getCallQueuesLists()"
     @deleteList="(...args) => deleteList(...args)"
     @activeBanner="$emit('activeBanner')"
     @successMsg="$emit('successMsg', $event)"
     @success="$emit('success', $event)"
     @sort="(this.currentSort = $event), sort($event)" />
   </div>

   <div v-else class="justify-center pt-20">
    <EmptyState
     :title="$t('emptyStateTitle', { title: $t('callQueue') })"
     :subtitle="$t('emptyStateSubtitle')" />
   </div>
  </div>
 </div>
 <ask-confirmation-dialog ref="askConfirmationDialog"></ask-confirmation-dialog>
</template>

<script>
import axios from "axios";
import { PlusIcon } from "@heroicons/vue/solid";
import TablePagination from "../components/TablePagination.vue";
import CallQueuesHeader from "../components/CallQueuesHeader.vue";
import SearchFilter from "../components/SearchFilter.vue";
import CreateNewCallQueue from "../components/CreateNewCallQueue.vue";
import UpdateCallQueueForm from "../components/UpdateCallQueueForm.vue";
import SuccessBanner from "../components/SuccessBanner.vue";
import CallQueuesTable from "../components/CallQueuesTable.vue";
import EmptyState from "../components/EmptyState.vue";
import PageHeading from "../components/PageHeading.vue";
import AskConfirmationDialog from "../components/AskConfirmationDialog.vue";
import { mapGetters } from "vuex";

const account = localStorage.getItem("account");
const userPermissions = JSON.parse(localStorage.getItem("userPermissions"));

export default {
 props: ["search"],
 components: {
  EmptyState,
  PageHeading,
  PlusIcon,
  TablePagination,
  CallQueuesHeader,
  CallQueuesTable,
  SearchFilter,
  CreateNewCallQueue,
  UpdateCallQueueForm,
  SuccessBanner,
  AskConfirmationDialog,
 },
 data() {
  return {
   thead: [
    { name: "Nom de la règle", sort: "name", isSort: false },
    { name: "Active", sort: "active", isSort: false },
    { name: "Type de ressource", sort: "type", isSort: false },
    { name: "Ressource", sort: "number", isSort: false },
   ],
   callQueuesLists: [],
   callQueuesGroups: [],
   callQueueData: {},
   account,
   openForm: false,
   currentSort: "id",
   currentSortDir: "asc",
   callQueueId: "",
   callQueueName: "",
   openUpdateForm: false,
   key: false,
   userPermissions,
   callQueuesOptions: null,
   hostsNameOptions: [],
   hostsOptions: {},
   isPopoverOpen: false,
   file: "",
   preview: false,
   previewData: [],
   errorFormMandateUpload: false,
   replaceAll: false,
   openBulkEditForm: false,
   itemsSelected: false,
  };
 },
 methods: {
  downloadExcelFile() {
   // The ID of your Google Sheet from the URL:
   // https://docs.google.com/spreadsheets/d/1yzdiBUMjUcChUApeBQl0Gy5Fq1N2SYB_R6ZjigRWHag/edit?usp=sharing
   const spreadsheetId = "1yzdiBUMjUcChUApeBQl0Gy5Fq1N2SYB_R6ZjigRWHag";

   // Construct the direct export URL for an XLSX file from Google Sheets
   const fileUrl = `https://docs.google.com/spreadsheets/d/${spreadsheetId}/export?format=xlsx`;
   const fileName = "inbound_rules_import.xlsx"; // The name the user will see for the downloaded file

   // Create a temporary anchor element
   const link = document.createElement("a");
   link.href = fileUrl;
   link.setAttribute("download", fileName); // Set the download attribute with the desired file name
   link.style.display = "none"; // Hide the link

   // Append the link to the document body
   document.body.appendChild(link);

   // Programmatically click the link to trigger the download
   link.click();

   // Clean up: remove the link from the document body after a short delay
   // (to ensure the click event has processed)
   setTimeout(() => {
    document.body.removeChild(link);
   }, 100);
  },
  dropHandler(ev) {
   console.log("File(s) dropped");

   // Prevent default behavior (Prevent file from being opened)
   ev.preventDefault();

   if (ev.dataTransfer.items) {
    // Use DataTransferItemList interface to access the file(s)
    for (var i = 0; i < ev.dataTransfer.items.length; i++) {
     // If dropped items aren't files, reject them
     const type = ev.dataTransfer.items[i].type;

     if (
      type === "multipart/form-data" ||
      type ===
       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
     ) {
      var file = ev.dataTransfer.items[i].getAsFile();
      this.file = file;
      this.errorFormMandateUpload = false;
     } else {
      this.errorFormMandateUpload = true;
     }
    }
   } else {
    // Use DataTransfer interface to access the file(s)
    for (var i = 0; i < ev.dataTransfer.files.length; i++) {
     console.log("... file[" + i + "].name = " + ev.dataTransfer.files[i].name);
    }
   }
  },
  dragOverHandler(ev) {
   // Prevent default behavior (Prevent file from being opened)
   ev.preventDefault();
  },
  handleFileUpload() {
   let type = this.$refs.file.files[0].type;

   if (
    type === "multipart/form-data" ||
    type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
   ) {
    this.file = this.$refs.file.files[0];
    this.errorFormMandateUpload = false;
   } else {
    this.errorFormMandateUpload = true;
   }
  },
  async submitFile(noFileMsg) {
   let title = this.$t("Remplacer tous les éléments");
   let confirmationMessage = this.$t("wishToContinue");
   let confirmButton = this.$t("delete");
   let goBack = this.$t("cancel");
   /* Initialize the form data */
   let formData = new FormData();
   formData.append("file", this.file);
   formData.append("replace_all", this.replaceAll ? 1 : 0);

   /* Add the form data we need to submit */
   if (this.file) {
    this.$emit("setLoading", true);

    if (this.replaceAll) {
     const r = await this.$refs.askConfirmationDialog.show({
      title: title,
      message: confirmationMessage,
      okButton: confirmButton,
      cancelButton: goBack,
      action: "delete",
     });
     if (r) {
      axios
       .post(
        `${this.$cookie.getCookie(
         "API"
        )}/api/v1/callQueues/import?customerAccount=${this.account}`,
        formData,
        {
         headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
         },
        }
       )
       .then(res => {
        this.$emit("activeBanner");
        this.$emit("success", true);
        this.$emit("successMsg", this.$t("successMsg"));
        this.getCallQueuesLists();
       })
       .catch(err => {
        this.$emit("setLoading", false);
        console.error(err);
        this.$emit("activeBanner");
        this.$emit("success", false);
        // Use the errorHandling method
        this.errorHandling(err);
        // Display both the error message and details if available
        let errorMessage = this.errorDataResponse;
        if (this.errorDetails && this.errorDetails.length > 0) {
         errorMessage += ": " + this.errorDetails.join(", ");
        }
        this.$emit("successMsg", errorMessage);
       });
      this.file = "";
     }
    } else {
     axios
      .post(
       `${this.$cookie.getCookie(
        "API"
       )}/api/v1/callQueues/import?customerAccount=${this.account}`,
       formData,
       {
        headers: {
         "Content-Type": "multipart/form-data",
         Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
       }
      )
      .then(res => {
       this.$emit("activeBanner");
       this.$emit("success", true);
       this.$emit("successMsg", this.$t("successMsg"));
       this.getCallQueuesLists();
      })
      .catch(err => {
       console.error(err);
       this.$emit("setLoading", false);
       this.$emit("activeBanner");
       this.$emit("success", false);
       // Use the errorHandling method
       this.errorHandling(err);
       // Display both the error message and details if available
       let errorMessage = this.errorDataResponse;
       if (this.errorDetails && this.errorDetails.length > 0) {
        errorMessage += ": " + this.errorDetails.join(", ");
       }
       this.$emit("successMsg", errorMessage);
      });
     this.file = "";
    }
   }

   /* Make the request to the POST /single-file URL  */
  },
  async deleteList(...args) {
   let id = args[0];
   let name = args[1];
   let title = this.$t("Supprimer la règle entrante", { name: name });
   let confirmationMessage = this.$t("wishToContinue");
   let confirmButton = this.$t("delete");
   let goBack = this.$t("cancel");
   let successMsg = this.$t("elementDeletedSuccessfully", {
    element: this.$t("Règle entrante"),
   });
   const options = {
    method: "DELETE",
    url: `${this.$cookie.getCookie("API")}/api/v1/callQueues/${id}`,
    params: { customerAccount: this.account },
    headers: {
     "Content-Type": "application/json",
     Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
   };
   const r = await this.$refs.askConfirmationDialog.show({
    title: title,
    message: confirmationMessage,
    okButton: confirmButton,
    cancelButton: goBack,
    action: "delete",
   });
   if (r) {
    axios
     .request(options)
     .then(response => {
      this.$emit("activeBanner");
      this.$emit("success", true);
      this.$emit("successMsg", successMsg);
      this.getCallQueuesLists();
     })
     .catch(err => {
      console.error(err);
      this.$emit("activeBanner");
      this.$emit("success", false);
      this.$emit("successMsg", this.errorDataResponse);
     });
   }
  },
  openEditForm(data) {
   this.openForm = false;
   this.openUpdateForm = true;
   this.callQueueId = data.id;
   this.editData = data;
   window.scrollTo(0, 100);
  },
  async bulkDelete(data) {
    let title = this.$t("Supprimer les règles entrantes");
    let confirmationMessage = this.$t("wishToContinue");
    let confirmButton = this.$t("delete");
    let goBack = this.$t("cancel");
    let successMsg = this.$t("elementsDeletedSuccessfully", {
      element: this.$t("Règle entrante"),
    });
    const options = {
      method: "DELETE",
      url: `${this.$cookie.getCookie("API")}/api/v1/callQueues/bulk/delete`,
      params: { 
        customerAccount: this.account,
        ids: data,
      },
      headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    const r = await this.$refs.askConfirmationDialog.show({
      title: title,
      message: confirmationMessage,
      okButton: confirmButton,
      cancelButton: goBack,
      action: "delete",
    });

    if (r) {
      axios
      .request(options)
      .then(response => {
        this.$emit("activeBanner");
        this.$emit("success", true);
        this.$emit("successMsg", successMsg);
        this.getCallQueuesLists();
      })
      .catch(err => {
        console.error(err);
        this.$emit("activeBanner");
        this.$emit("success", false);
        this.$emit("successMsg", this.errorDataResponse);
      });
    }
  },
  async getCallQueuesLists() {
   this.$emit("setLoading", true);
   const res = await axios.get(
    `${this.$cookie.getCookie("API")}/api/v1/callQueues?customerAccount=${
     this.account
    }`,
    {
     headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
    }
   );

   this.$emit("setLoading", false);

   try {
    this.callQueuesLists = res.data;
   } catch (error) {
    this.$emit("setLoading", false);
    this.errorHandling(error);
   }
  },
  async getCallQueuesOptions() {
   this.$emit("setLoading", true);
   const res = await axios.get(
    `${this.$cookie.getCookie(
     "API"
    )}/api/v1/callQueues/options?customerAccount=${this.account}`,
    {
     headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
    }
   );

   this.$emit("setLoading", false);

   try {
    if (res?.data?.hosts) {
     this.hostsNameOptions = Object.keys(res?.data?.hosts);
     this.hostsOptions = res?.data?.hosts;
     if (this.hostName) {
      this.callQueuesOptions = res.data?.hosts[this.hostName];
     } else {
      this.callQueuesOptions = res.data?.hosts[0];
     }
     // this.callQueuesDIDOptions = res.data?.dids;
     // this.callQueuesExtensionOptions = res.data?.extensions;
     // this.callQueuesQueueOptions = res.data?.queues;
    }
   } catch (error) {
    this.errorHandling(error);
   }
  },
  async getCallQueuesGroups() {
   this.$emit("setLoading", true);
   const res = await axios.get(
    `${this.$cookie.getCookie("API")}/api/v1/callQueueGroups?customerAccount=${
     this.account
    }`,
    {
     headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
     },
    }
   );

   this.$emit("setLoading", false);

   try {
    this.callQueuesGroups = res.data;
   } catch (error) {
    this.errorHandling(error);
   }
  },
  sort(s) {
   if (s === this.currentSort) {
    this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
   }
   this.currentSort = s;
  },
  sortedCallQueues() {
   return this.callQueuesLists.sort((a, b) => {
    let toBeSorted = this.currentSort;
    let modifier = 1;
    if (this.currentSortDir === "desc") modifier = -1;
    if (toBeSorted === "number") {
     if (parseFloat(a[toBeSorted]) < parseFloat(b[toBeSorted]))
      return -1 * modifier;
     if (parseFloat(a[toBeSorted]) > parseFloat(b[toBeSorted]))
      return 1 * modifier;
    } else if (typeof a[toBeSorted] === "string") {
     if (a[toBeSorted].toLowerCase() < b[toBeSorted].toLowerCase())
      return -1 * modifier;
     if (a[toBeSorted].toLowerCase() > b[toBeSorted].toLowerCase())
      return 1 * modifier;
    }
    return 0;
   });
  },
  filterCallQueuesLists() {
   return this.sortedCallQueues().filter(res => {
    if (this.search) {
     const searchLower = this.search.toLowerCase();

     const nameMatch = res.name?.toLowerCase().includes(searchLower);
     const numberMatch = res.number?.includes(searchLower);
     const didNumberMatch = res.did_number?.includes(searchLower);
     const typeMatch = res.type?.toLowerCase().includes(searchLower);

     return nameMatch || numberMatch || typeMatch || didNumberMatch;
    }
    return res;
   });
  },
 },
 mounted() {
  this.getCallQueuesLists();
  this.getCallQueuesGroups();
  this.getCallQueuesOptions();
 },
 computed: {
  ...mapGetters(["hostName"]),
 },
};
</script>

<style></style>
